import React from "react";

import { Box, Theme } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { makeStyles } from "tss-react/mui";

import { APP_BAR_HEIGHT } from "../../AppBar";
import { useSidebarContext } from "../Sidebar";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    height: `calc(100vh - ${APP_BAR_HEIGHT}px - 2px)`, // -2px for the weird gap between panel and appbar
    width: "390px",
    margin: `calc(${theme.spacing(12)} + 2px) 0 0`, // +2px for the weird gap between panel and appbar
    overflow: "hidden",
    zIndex: 999,
    padding: "20px",
  },
}));

interface HoverBaseProps {
  componentName: string;
}

const HoverBase: React.FC<HoverBaseProps> = ({ componentName, children }) => {
  const { state, dispatch } = useSidebarContext();
  const { classes } = useStyles();
  const open = Boolean(state.openedComponent === componentName.toLowerCase());
  return (
    <>
      {open && (
        <ClickAwayListener
          mouseEvent={state.keepOpen ? false : "onClick"}
          onClickAway={() => dispatch({ type: "close-component" })}
        >
          <Box
            bgcolor="white"
            onMouseEnter={() => dispatch({ type: "keep-open", payload: true })}
            onMouseLeave={() => dispatch({ type: "keep-open", payload: false })}
            className={classes.root}
          >
            {children}
          </Box>
        </ClickAwayListener>
      )}
    </>
  );
};
export default HoverBase;
